import React from 'react';
import { Layout, Typography, Row, Col } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants, containerVariants } from '../utils/useAnimations';
import { handleAnchorClick } from '../utils/navigation';
import { useNavigate } from 'react-router-dom';

const { Footer: AntFooter } = Layout;
const { Title } = Typography;

export const Footer: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AntFooter className="bg-neutral-black text-neutral-white py-10">
      <motion.div 
        className="max-w-[1440px] mx-auto px-20"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <Row gutter={[40, 40]}>
          <Col xs={24} md={6}>
            <motion.div variants={standardVariants}>
              <Title level={3} className="!text-xl !font-bold !mb-5 !text-neutral-white gap-2 flex items-center">
                <img src="/img/svg/logo-footer.svg" className="h-8" alt=''/>
                <span>AndyK.app</span>
              </Title>
            </motion.div>
          </Col>
          
          <Col xs={24} md={18}>
            <Row gutter={[40, 20]}>
              <Col xs={12} md={8}>
                <motion.ul 
                  className="space-y-3 list-none p-0"
                  variants={standardVariants}
                >
                  <li>
                    <a tabIndex={0} className="a-white" onClick={(e) =>{ navigate(`/`)}} 
                      onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate('/');
                      }
                      }}
                      >
                      Accueil
                    </a>
                  </li>
                  <li>
                    <a tabIndex={0} className="a-white" onClick={(e) =>{ navigate(`/#parcours`)}} 
                      onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate('/#parcours');
                      }
                      }}
                      >
                      Les parcours
                    </a>
                  </li>
                  <li>
                    <a className="a-gray" aria-disabled>
                      Transcription textuelle
                    </a>
                  </li>
                  <li>
                    <a className="a-gray" aria-disabled>
                      Les handicaps
                    </a>
                  </li>
                </motion.ul>
              </Col>
              
              <Col xs={12} md={8}>
                <motion.ul 
                  className="space-y-3 list-none p-0"
                  variants={standardVariants}
                >
                  <li>
                    <a href="mailto:contact@andyk.app" className="a-white">
                      Nous contacter
                    </a>
                  </li>
                  <li>
                    <a className="a-gray" aria-disabled>
                      Faire un don
                    </a>
                  </li>
                  <li>
                    <a className="a-gray" aria-disabled>
                      Plan du site
                    </a>
                  </li>
                  <li>
                    <a className="a-gray" aria-disabled>
                      Accessibilité : non conforme
                      Audit en cours
                    </a>
                  </li>
                </motion.ul>
              </Col>
              
              <Col xs={12} md={8}>
                <motion.ul 
                  className="space-y-3 list-none p-0"
                  variants={standardVariants}
                >
                  <li>
                    <a tabIndex={0} className="a-white" onClick={(e) =>{ navigate(`/mentions-legales`)}}
                      onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate('/mentions-legales');
                      }
                      }}>
                      Mentions légales
                    </a>
                  </li>
                  <li>
                    <a tabIndex={0} className="a-white" onClick={(e) =>{ navigate(`/cgu`)}} 
                      onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate('/cgu');
                      }
                      }}>
                      CGU
                    </a>
                  </li>
                </motion.ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </motion.div>
    </AntFooter>
  );
};